/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit, IconEye, IconFileImport } from '@tabler/icons-react';
import { Status, TipoCodigo } from '../../../../../business/events/general';
import DeleteConfirmPopover from '../../../../../components/DeleteConfirmPopover';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { Permission } from '../../../../../models/core/departments.type';
import { EventSearchResponseType } from '../../../../../models/core/events.type';
import theme from '../../../../../theme';
import { validate } from '../../../../../utils/permission.utils';

type DataViewActionProps = {
  item: EventSearchResponseType;
  confirmActionResult(
    items: EventSearchResponseType[],
    action: string,
    value: string | null,
    confirmed: boolean,
    extras: any
  ): void;
  extras: any;
};

export default function DataViewActions(props: DataViewActionProps) {
  const [currentUser] = useCurrentUser();

  return (
    <Group>
      {validate(Permission.EventView, currentUser.permissoes) && (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Visualizar">
          <ActionIcon
            size="sm"
            radius="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.primary?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult([props.item], 'visualizar', null, true, props.extras);
            }}
          >
            <IconEye size={15} color={theme?.colors?.primary?.[6]} />
          </ActionIcon>
        </Tooltip>
      )}
      {props.item.codigoEventoStatus !== Status.Cancelado &&
        props.item.codigoEventoStatus !== Status.Finalizado &&
        validate(Permission.EventEdit, currentUser.permissoes) && (
          <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
            <ActionIcon
              size="sm"
              color="primary"
              style={{ borderColor: theme?.colors?.accent?.[6] }}
              variant="outline"
              onClick={() => {
                props.confirmActionResult([props.item], 'editar', null, true, props.extras);
              }}
            >
              <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
            </ActionIcon>
          </Tooltip>
        )}
      {props.item.codigoEventoTipo !== TipoCodigo.Expiracao &&
        props.item.codigoEventoTipo !== TipoCodigo.Cobranca &&
        props.item.codigoEventoTipo !== TipoCodigo.Comissao &&
        !props.item.obsoleto &&
        validate(Permission.EventView, currentUser.permissoes) && (
          <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Importar">
            <ActionIcon
              size="sm"
              radius="sm"
              color="primary"
              style={{ borderColor: theme?.colors?.gray?.[6] }}
              variant="outline"
              onClick={() => {
                props.confirmActionResult([props.item], 'importar', null, true, props.extras);
              }}
            >
              <IconFileImport size={15} color={theme?.colors?.gray?.[6]} />
            </ActionIcon>
          </Tooltip>
        )}
      {!(
        props.item.codigoEventoStatus === Status.Finalizado &&
        (props.item.codigoEventoTipo === TipoCodigo.Cobranca ||
          props.item.codigoEventoTipo === TipoCodigo.Coleta ||
          props.item.codigoEventoTipo === TipoCodigo.Comissao ||
          props.item.codigoEventoTipo === TipoCodigo.Fechamento ||
          props.item.codigoEventoTipo === TipoCodigo.MobilizacaoEnviar ||
          props.item.codigoEventoTipo === TipoCodigo.MobilizacaoRetirar)
      ) &&
        validate(Permission.EventDelete, currentUser.permissoes) && (
          <DeleteConfirmPopover
            label="Excluir"
            message="Esta ação removerá o evento."
            variant="outline"
            onConfirm={() => {
              props.confirmActionResult([props.item], 'excluir', null, true, props.extras);
            }}
            onCancel={() => {
              props.confirmActionResult([props.item], 'excluir', null, false, props.extras);
            }}
          />
        )}
    </Group>
  );
}
